import { render, staticRenderFns } from "./AbsenceRequestHistory.vue?vue&type=template&id=23fd436a&scoped=true"
import script from "./AbsenceRequestHistory.vue?vue&type=script&lang=js"
export * from "./AbsenceRequestHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fd436a",
  null
  
)

export default component.exports